﻿function getrecommanded2() {
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/activities/getAll?page=1&size=3',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    $('#partial-view').html('');
                    var isAdd = false;

                    if (result.data.length == 1) {
                        result.data.push(result.data[0]);
                        result.data.push(result.data[0]);
                    } else if (result.data.length == 2) {
                        result.data.push(result.data[0]);
                    }

                    for (var i = 0; i < result.data.length; i++) {
                        var info = result.data[i];
                        if (info.poster_url == null || info.poster_url.length == 0) {
                            continue;
                        }
                        isAdd = true;

                        var html = '<li>' +
                            '<a target="_blank" href="' + ROOT + '/activities/' + info.id + '">' +
                            '<img src="' + info.poster_url + '?w=676&h=280&s=3">' +
                            '</a>' +
                            '</li>';

                        $('#partial-view').append(html);
                    }

                    if (isAdd) {
                        $('.scrollview2').show();
                        var css = 'background: url(' + ROOT + '/static/partialviewslider/btn.png);background-size:20px 30px;';
                        $('#partial-view').partialViewSlider({
                            width: 686 / 1110 * 100,
                            prevHtml: '<i class="material-icons material-icons-prev" style="' + css + '"></i>',
                            nextHtml: '<i class="material-icons material-icons-next" style="' + css + '"></i>',
                        });
                    }
                } else {
                    // alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
}

$(function () {
    // getrecommanded2();

    gethotest(3);

    getSuggest();

    $('.showtab').click(function () {
        $('.active').removeClass('active');
        $(this).addClass('active');

        if ($(this).data('type') == 2) {
            $('.curentlives').hide();
            $('.curentlives2').show();
        } else {
            $('.curentlives').show();
            $('.curentlives2').hide();
        }
    });
});


window.getSuggest = function () {
    showWait();
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/content?sort=1&page=1&size=6',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                var str = '';
                for (var n = 0; n < result.data.length; n++) {
                    if (n == 6) {
                        break;
                    }
                    var info = result.data[n];
                    var targetHtml = '<a target="_blank" href="' + ROOT + '/content/' + info.id + '">';

                    var html =
                        '<div class="liveinfo">' +
                        targetHtml +
                        '<div class="liveinfo-img">' +
                        '<img src="' + info.cover_url + '?w=192&h=116&s=3">' +
                        '<div class="liveinfo-type"></div>' +
                        '<div class="liveinfo-hover"></div>' +
                        '</div>' +
                        '<div class="liveinfo-title">' +
                        '<div class="liveinfo-title-name ellipse-two">' + info.title + '</div>' +
                        '</div>' +
                        '<div class="liveinfo-user">' +
                        '<div class="liveinfo-user-name">' + (info.author_nickname || '') + '</div>' +
                        '<div class="liveinfo-user-visitcount">' + info.like_count + '</div>' +
                        '</div>' +
                        '</a>' +
                        '</div>';

                    str += html;
                }

                var html =
                    '<div class="curentlives">' +
                    '    <div class="livelist">' +
                    str +
                    '    </div>' +
                    '</div>';

                $('.recommend-itmes').append(html);
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
        },
        complete: function (XMLHttpRequest, textStatus) {
        }
    });
};
